<script lang="ts" setup>
// Props are optional - component can be used with default content or customized
interface Props {
    coverageAmount?: string;
    contactEmail?: string;
    contactPhone?: string;
}

withDefaults(defineProps<Props>(), {
    coverageAmount: '$500,000',
    contactEmail: 'recovery@certifid.com',
    contactPhone: '(616) 202-6612',
});
</script>

<template>
    <div class="coverage-banner">
        <div class="coverage-banner__header">
            <app-icon icon="cd-ic-money-shield" class="coverage-banner__icon" />
            <span class="coverage-banner__title"> MONEY PROTECTION PLAN </span>
        </div>
        <p class="coverage-banner__body">
            Your purchase of CertifID's Money Protection Plan insures your funds
            up to {{ coverageAmount }} when you follow these instructions to
            transfer money. You also have access to Fraud Recovery Services
            should you transfer funds to a different account.
        </p>
        <p class="coverage-banner__subtext">
            If you suspect you might be a victim of fraud, contact
            {{ contactEmail }} or call {{ contactPhone }} as soon as possible.
        </p>
    </div>
</template>

<style lang="scss" scoped>
@use "certifid-v2-client-hub-styles" as *;

.coverage-banner {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    gap: 0.5rem;
    padding: 1rem;
    background: #f6f7f8;
    border-radius: 0.375rem;

    &__header {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    &__icon {
        flex-shrink: 0;
        font-size: 1.5rem;
        color: $green;
    }

    &__title {
        font-size: 0.9rem;
        font-weight: 700;
        color: $black-high;
    }

    &__body {
        font-size: 0.9rem;
        line-height: 150%;
        color: $black-high;
        margin: 0;
    }

    &__subtext {
        font-size: 0.9rem;
        line-height: 150%;
        color: $black-high;
        margin: 0;
    }
}
</style>
